import toast, { ToastOptions } from 'react-hot-toast'

/**
 * Custom toast hook for consistent notifications
 * Provides easy-to-use methods for success, error, loading, and info toasts
 */
export function useToast() {
  const showSuccess = (message: string, options?: ToastOptions) => {
    return toast.success(message, {
      duration: 4000,
      ...options,
    })
  }

  const showError = (message: string, options?: ToastOptions) => {
    return toast.error(message, {
      duration: 5000, // Longer duration for errors
      ...options,
    })
  }

  const showLoading = (message: string, options?: ToastOptions) => {
    return toast.loading(message, {
      ...options,
    })
  }

  const showInfo = (message: string, options?: ToastOptions) => {
    return toast(message, {
      icon: 'ℹ️',
      duration: 4000,
      ...options,
    })
  }

  const dismiss = (toastId?: string) => {
    toast.dismiss(toastId)
  }

  const promise = <T,>(
    promise: Promise<T>,
    messages: {
      loading: string
      success: string | ((data: T) => string)
      error: string | ((error: Error) => string)
    },
    options?: ToastOptions
  ) => {
    return toast.promise(
      promise,
      messages,
      {
        ...options,
      }
    )
  }

  return {
    success: showSuccess,
    error: showError,
    loading: showLoading,
    info: showInfo,
    dismiss,
    promise,
  }
}

